import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { CaretDown } from '@phosphor-icons/react/dist/ssr/CaretDown';

import { InputType } from '@/types/general';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';

interface groupDto {
  group: string | undefined;
  playerId: string;
}

function PlayerGroupSection(): React.JSX.Element {
  const [selectedGroup, setSelectedGroup] = useState<groupDto>({
    group: undefined,
    playerId: '',
  });
  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<CaretDown />} aria-controls="panel1-content" id="panel1-header">
        <Typography component="span">Player Group</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack gap={2}>
          <Grid container spacing={1}>
            <CustomConfigInputV2
              label="Select Groups"
              name="group"
              type={InputType.SELECT}
              value={selectedGroup.group}
              defaultData={selectedGroup}
              setDefaultData={setSelectedGroup}
            />
          </Grid>
          <Stack direction="row" gap={2} sx={{ justifyContent: 'end' }}>
            <Button variant="contained" color="error">
              Remove From Group
            </Button>
            <Button variant="contained" color="success">
              Create New Group
            </Button>
            <Button variant="contained" color="primary">
              Add to Existing Group
            </Button>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}

export default PlayerGroupSection;
